import request from '@/utils/request'

const base = '/db/dept'

export function deptPageQuery(data) {
    return request({
        url: base+'/dept-page-query',
        method: 'post',
        data
    })
}

export function batchOpen(data) {
    return request({
        url: base+'/batch-open',
        method: 'post',
        data
    })
}

